<script lang="ts" setup>
import AUApi from "@/api";
import { ref, onMounted, reactive } from "vue";
import {
  globalsStt,
  globalsDruck,
  globalsBezeichnung,
  checkNode,
} from "@/local";
import { onShowSite } from "@/NavigationHelper";
import { Globals } from "@/Globals";
import {
  getKennungTitle,
  getKennungValueDisplay,
  getKZValueDisplay,
} from "@/DataHelper";
import {
  mountedBase,
  onSave,
  BaseSetup,
  onDelete,
  openDruckVorschau,
} from "@/DataLoaderStatic";
const props = defineProps<{
  druckItems?: ALLDruck[];
}>();
const emit = defineEmits(["back", "save"]);
let printItems = ref<ALLDruck[]>([]);
let bezeichnung = ref<string>("");
let tab = ref<string>("");
let editAzureBeleg = ref<boolean>(false);

let kostenQuery = ref<string>("Web_UebersichtAngefallenerKosten");
const pageParams: DataPageParameter = {
  zeitbereich: AUApi.Current.zeitbereich,
  insertMode: false,
  query: "WebReisePlanung_Pers",
  aic: AUApi.Current.user.aic,
  emitBack: () => emit("back"),
};

const uiData = reactive<DataPageUIData>(BaseSetup(pageParams));
onMounted(async () => {
  if (checkNode("RK_Belegerkennung")) {
    kostenQuery.value = "Web_UebersichtBelegeProReise";
    editAzureBeleg.value = true;
    const Stamm = globalsStt(Globals.Stt, 0, "RK_TRAVEL");
    AUApi.Current.setSyncStamm(Stamm.aic, pageParams.queryAIC ?? 0);

    if (!pageParams.jokerStt) {
      pageParams.jokerStt = [];
    }
    pageParams.jokerStt.push({
      sync: pageParams.queryAIC ?? 0,
      aic: Stamm.aic,
    });
  }
  pageParams.bewegungsdaten = false;
  printItems.value = props.druckItems ?? [];
  await mountedBase(uiData, pageParams, false);
  if (!uiData.showLoading && uiData.data && uiData.data.length > 0) {
    const row = uiData.data[0];
    bezeichnung.value = getKZValueDisplay(row, "subject", uiData.columns);
    const zweck = getKennungValueDisplay(row, "RK_REISEZWECK", uiData.columns);
    if (!props.druckItems) {
      const stammTyp = globalsStt(Globals.Stt, 0, "RK_TRAVEL");
      printItems.value = globalsDruck(Globals.Begriff, true, stammTyp);
    }
    uiData.showLoading = false;
    uiData.initialized = true;
  } else {
    // keine Daten: initialisiert, aber ohne row-Daten (Template sollte ggf. leer bleiben)
    uiData.showLoading = false;
    uiData.initialized = true;
  }
});

function openBuchungen() {
  const von = uiData.zeitbereich?.von.toISOString();
  emit("back");
  onShowSite({
    title: "",
    site: "SoftTermBuchungen",
    data: { zeitbereich: uiData.zeitbereich, goDate: von },
    callOnLeave: () => {
      return true;
    },
  });
}
</script>
<template>
  <v-card :loading="uiData.showLoading" v-if="uiData.initialized">
    <v-toolbar
      density="compact"
      class="dvhBackground pl-5"
      style="color: white"
    >
      <div class="headline font-weight-light white--text">
        {{ bezeichnung }}
      </div>
      <v-spacer></v-spacer>
      <v-btn
        icon="mdi-magnify-plus-outline"
        variant="text"
        @click.prevent.stop="openBuchungen()"
      >
      </v-btn>
      <v-menu
        :close-on-content-click="false"
        v-if="printItems && printItems.length"
      >
        <template v-slot:activator="{ props }">
          <v-btn variant="text" v-bind="props" icon="mdi-printer"></v-btn>
        </template>

        <v-list>
          <v-list-item
            v-for="(printItem, index) in printItems"
            :key="'p' + index"
            @click="openDruckVorschau(uiData, pageParams, printItem)"
          >
            <v-tooltip location="bottom" :text="printItem?.tooltip">
              <template v-slot:activator="{ props }">
                <v-list-item-title v-bind="props">
                  {{ printItem.bezeichnung }}
                </v-list-item-title>
              </template>
            </v-tooltip>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-btn variant="text" icon="mdi-close" @click="emit('back')"></v-btn>
    </v-toolbar>

    <v-tabs v-model="tab" density="compact" tile slim show-arrows>
      <v-tab value="one">{{
        globalsBezeichnung(Globals.Begriff, "Reise", "Reise")
      }}</v-tab>
      <v-tab value="two">{{
        globalsBezeichnung(Globals.Begriff, "Web_Belege", "Belege")
      }}</v-tab>
    </v-tabs>
    <v-tabs-window v-model="tab">
      <v-tabs-window-item value="one" bg-color="success">
        <v-card-text class="reise-tab">
          <v-row class="pt-2" no-gutters>
            <v-col class="dvhCol">
              <span style="white-space: nowrap"
                >{{ getKennungTitle("RK_REISEZWECK", uiData.columns) }}:
              </span>
            </v-col>
            <v-col class="dvhSpan">
              <span style="white-space: nowrap">{{
                getKennungValueDisplay(
                  uiData.data[0],
                  "RK_REISEZWECK",
                  uiData.columns,
                )
              }}</span></v-col
            >
          </v-row>
          <v-row no-gutters>
            <v-col class="dvhCol">
              <span style="white-space: nowrap"
                >{{ getKennungTitle("BEGIN", uiData.columns) }}:
              </span>
            </v-col>
            <v-col class="dvhSpan">
              <span style="white-space: nowrap">{{
                getKennungValueDisplay(uiData.data[0], "BEGIN", uiData.columns)
              }}</span>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col class="dvhCol">
              <span style="white-space: nowrap"
                >{{ getKennungTitle("RK_REISE_BEENDET", uiData.columns) }}:
              </span>
            </v-col>
            <v-col class="dvhSpan">
              <span style="white-space: nowrap">{{
                getKennungValueDisplay(
                  uiData.data[0],
                  "RK_REISE_BEENDET",
                  uiData.columns,
                )
              }}</span>
            </v-col>
          </v-row>
          <!-- 
          <v-row no-gutters>
            <v-col class="dvhCol">
              <span style="white-space: nowrap"
                >{{ getKennungTitle("RK_KATEGORIE", uiData.columns) }}:
              </span>
            </v-col>

            <v-col class="dvhCol">
              <span style="white-space: nowrap">{{
                getKennungValueDisplay(
                  uiData.data[0],
                  "RK_KATEGORIE",
                  uiData.columns,
                )
              }}</span>
            </v-col>
          </v-row> -->
          <v-row no-gutters>
            <v-col class="dvhCol">
              <span style="white-space: nowrap"
                >{{ getKennungTitle("RK_STATUSREISE", uiData.columns) }}:
              </span>
            </v-col>

            <v-col class="dvhSpan">
              <span style="white-space: nowrap">{{
                getKennungValueDisplay(
                  uiData.data[0],
                  "RK_STATUSREISE",
                  uiData.columns,
                )
              }}</span>
            </v-col>
          </v-row>
          <!-- <v-row no-gutters>
            <v-col class="dvhCol">
              <span style="white-space: nowrap"
                >{{ getKennungTitle("RK_VORGAENGER_STATUS", uiData.columns) }}:
              </span>
            </v-col>

            <v-col class="dvhCol">
              <span style="white-space: nowrap">{{
                getKennungValueDisplay(
                  uiData.data[0],
                  "RK_VORGAENGER_STATUS",
                  uiData.columns,
                )
              }}</span>
            </v-col>
          </v-row> -->
          <!-- <v-row>
            <v-col class="dvhCol">
              <span style="white-space: nowrap">
                {{ getKennungTitle("HINWEIS", uiData.columns) }}:</span
              >
            </v-col>

       <v-col class="dvhCol">
              {{
                getKennungValueDisplay(
                  uiData.data[0],
                  "HINWEIS",
                  uiData.columns
                )
              }}
            </v-col>
          </v-row>

          <v-row>
            <v-col style="white-space: nowrap"
              >{{ getKennungTitle("BESCHREIBUNG", uiData.columns) }}:
            </v-col>

            <v-col class="grid-item">
              {{
                getKennungValueDisplay(
                  uiData.data[0],
                  "BESCHREIBUNG",
                  uiData.columns
                )
              }}
            </v-col>
          </v-row> -->
          <v-row no-gutters>
            <v-col class="dvhCol pt-2">
              <span style="white-space: nowrap"
                >{{ getKennungTitle("diaten", uiData.columns) }}:
              </span>
            </v-col>
            <v-col class="dvhSpan pt-2">
              <span style="white-space: nowrap">{{
                getKennungValueDisplay(uiData.data[0], "diaten", uiData.columns)
              }}</span>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col class="dvhCol">
              <span style="white-space: nowrap"
                >{{ getKennungTitle("belege", uiData.columns) }}:
              </span>
            </v-col>

            <v-col class="dvhSpan">
              <span style="white-space: nowrap">{{
                getKennungValueDisplay(uiData.data[0], "belege", uiData.columns)
              }}</span>
            </v-col>
          </v-row>
          <v-row class="pb-1" no-gutters>
            <v-col class="dvhCol">
              <span style="white-space: nowrap">
                {{ getKennungTitle("km", uiData.columns) }}:
              </span>
            </v-col>

            <v-col class="dvhSpan">
              <span style="white-space: nowrap">{{
                getKennungValueDisplay(uiData.data[0], "km", uiData.columns)
              }}</span>
            </v-col>
          </v-row>
          <v-divider class="pt-2"></v-divider>
          <div></div>
          <v-row class="pt-1" no-gutters>
            <v-col class="dvhCol">
              <span style="white-space: nowrap"
                >{{ getKennungTitle("ALL_ROUND_PRICE", uiData.columns) }}:
              </span>
            </v-col>

            <v-col class="dvhSpan">
              <span style="white-space: nowrap">{{
                getKennungValueDisplay(
                  uiData.data[0],
                  "ALL_ROUND_PRICE",
                  uiData.columns,
                )
              }}</span>
            </v-col>
          </v-row>
          <EditTextArea class="pt-4" kennung="MEMO" />
          <EditTextArea class="pt-0" kennung="BESCHREIBUNG" />
        </v-card-text>
      </v-tabs-window-item>

      <v-tabs-window-item value="two" bg-color="success">
        <RkAdminDialogKosten
          :query="kostenQuery"
          :zeitbereichUebergabe="pageParams.zeitbereich"
          :aic="pageParams.queryAIC"
          :contentHight="400"
          :siteData="{
            editAzureBeleg: editAzureBeleg,
          }"
        />
      </v-tabs-window-item>
    </v-tabs-window>
  </v-card>
</template>

<style scoped>
.row {
  padding: 0px;
}
.dvhCol {
  padding-right: 0px;
  padding-left: 10px;
  padding-top: 0px;
  padding-bottom: 2px;
  align-items: left;
  text-align: left;
}
.dvhSpan {
  text-align: right;
  padding-top: 0px;
  padding-bottom: 2px;
}
.reise-tab :deep(.v-row) {
  margin-top: 0 !important;
}
.reise-tab :deep(.v-row + .v-row) {
  margin-top: 2px !important;
}
@media (max-width: 550px) {
  .dvhDialog {
    padding: 0px;
    min-width: 100%;
  }
}
</style>
